export default __webpack_public_path__ + "static/media/register_success.d824ba68.svg";